import { render } from "./billManage.vue?vue&type=template&id=67ee1ad5&scoped=true"
import script from "./billManage.vue?vue&type=script&lang=js"
export * from "./billManage.vue?vue&type=script&lang=js"

import "./billManage.vue?vue&type=style&index=0&id=67ee1ad5&lang=scss&scoped=true"
import "./billManage.vue?vue&type=style&index=1&id=67ee1ad5&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ee1ad5"]])

export default __exports__